<template>
  <div>
    <div v-for="(item, index) in vdata" :key="item.id" style="width: 100%; margin-bottom: 20px;">
      <!-- 设备编号 -->
      <div style="font-size: 16px; margin-bottom: 10px; font-weight: 500;">
        设备编号: {{ item.deviceNo }}
      </div>

      <!-- 餐前后提醒表格 -->
      <div>
        <h2 style="font-size: 18px; margin: 10px 0;">餐前后提醒</h2>
        <el-table :data="[item]" style="width: 100%" border>
          <!-- 提示音列 -->
          <el-table-column label="提示音" width="150" align="center">
            <template #default="scope">
              {{ scope.row.autoPlay === 1 ? '开启' : '关闭' }}
            </template>
          </el-table-column>

          <!-- 药品名称列 -->
          <el-table-column label="药品名称" width="150" align="center">
            <template #default="scope">
              {{ scope.row.detail1 || '未设置' }}
            </template>
          </el-table-column>

          <!-- 用药时间/提示列 -->
          <el-table-column label="用药时间/提示" align="center">
            <!-- 早餐前提醒 -->
            <el-table-column label="早餐前提醒" width="120">
              <template #default="scope">
                <div class="time-cell">
                  <div class="time-line">{{ formatTime(scope.row.breakfastBefore) }}</div>
                  <div class="medicine-line">{{ scope.row.breakfastBeforeDrug || '无' }}</div>
                </div>
              </template>
            </el-table-column>

            <!-- 早餐后提醒 -->
            <el-table-column label="早餐后提醒" width="120">
              <template #default="scope">
                <div class="time-cell">
                  <div class="time-line">{{ formatTime(scope.row.breakfastAfter) }}</div>
                  <div class="medicine-line">{{ scope.row.breakfastAfterDrug || '无' }}</div>
                </div>
              </template>
            </el-table-column>

            <!-- 午餐前提醒 -->
            <el-table-column label="午餐前提醒" width="120">
              <template #default="scope">
                <div class="time-cell">
                  <div class="time-line">{{ formatTime(scope.row.lunchBefore) }}</div>
                  <div class="medicine-line">{{ scope.row.lunchBeforeDrug || '无' }}</div>
                </div>
              </template>
            </el-table-column>

            <!-- 午餐后提醒 -->
            <el-table-column label="午餐后提醒" width="120">
              <template #default="scope">
                <div class="time-cell">
                  <div class="time-line">{{ formatTime(scope.row.lunchAfter) }}</div>
                  <div class="medicine-line">{{ scope.row.lunchAfterDrug || '无' }}</div>
                </div>
              </template>
            </el-table-column>

            <!-- 晚餐前提醒 -->
            <el-table-column label="晚餐前提醒" width="120">
              <template #default="scope">
                <div class="time-cell">
                  <div class="time-line">{{ formatTime(scope.row.dinnerBefore) }}</div>
                  <div class="medicine-line">{{ scope.row.dinnerBeforeDrug || '无' }}</div>
                </div>
              </template>
            </el-table-column>

            <!-- 晚餐后提醒 -->
            <el-table-column label="晚餐后提醒" width="120">
              <template #default="scope">
                <div class="time-cell">
                  <div class="time-line">{{ formatTime(scope.row.dinnerAfter) }}</div>
                  <div class="medicine-line">{{ scope.row.dinnerAfterDrug || '无' }}</div>
                </div>
              </template>
            </el-table-column>

            <!-- 睡前提醒 -->
            <el-table-column label="睡前提醒" width="120">
              <template #default="scope">
                <div class="time-cell">
                  <div class="time-line">{{ formatTime(scope.row.bedtime) }}</div>
                  <div class="medicine-line">{{ scope.row.bedtimeDrug || '无' }}</div>
                </div>
              </template>
            </el-table-column>
          </el-table-column>

          <!-- 操作列 -->
          <el-table-column label="操作" width="100" align="center">
            <template #default="scope">
              <el-button size="mini" @click="handleEdit(scope.row)">
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 其他提醒 -->
      <div style="margin-top: 20px;">
        <h2 style="font-size: 18px; margin: 10px 0;">其他提醒</h2>
        <el-table :data="[item]" style="width: 100%" border>
          <el-table-column label="提醒内容" width="200" align="center"></el-table-column>
          <el-table-column label="提醒1" width="150" align="center">
            <template #default="scope">
              {{ scope.row.otherRemind1 || '无' }}
            </template>
          </el-table-column>
          <el-table-column label="提醒2" width="150" align="center">
            <template #default="scope">
              {{ scope.row.otherRemind2 || '无' }}
            </template>
          </el-table-column>
          <el-table-column label="提醒3" width="150" align="center">
            <template #default="scope">
              {{ scope.row.otherRemind3 || '无' }}
            </template>
          </el-table-column>
          <el-table-column label="提醒4" width="150" align="center">
            <template #default="scope">
              {{ scope.row.otherRemind4 || '无' }}
            </template>
          </el-table-column>
          <el-table-column label="提醒5" width="150" align="center">
            <template #default="scope">
              {{ scope.row.otherRemind5 || '无' }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 其他设置 -->
      <div style="margin-top: 20px;">
        <h2 style="font-size: 18px; margin: 10px 0;">其他设置</h2>
        <el-table :data="[item]" style="width: 100%" border>
          <el-table-column label="服务器地址" width="200" align="center">
            <template #default="scope">
              {{ scope.row.serverUrl || '未设置' }}
            </template>
          </el-table-column>
          <el-table-column label="端口" width="100" align="center">
            <template #default="scope">
              {{ scope.row.port || '未设置' }}
            </template>
          </el-table-column>
          <el-table-column label="音量" width="100" align="center">
            <template #default="scope">
              {{ scope.row.volume || '默认' }}
            </template>
          </el-table-column>
          <el-table-column label="开始日期" width="150" align="center">
            <template #default="scope">
              {{ formatDate(scope.row.startDate) }}
            </template>
          </el-table-column>
          <el-table-column label="结束日期" width="150" align="center">
            <template #default="scope">
              {{ formatDate(scope.row.endDate) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "@/vuex/eventBus";

export default {
  name: "MedicineReminder",
  data() {
    return {
      vdata: [],
      deviceNo: ''
    };
  },
  methods: {
    // 获取设备用药提醒列表
    getOldmanList() {
      console.log(this.$route.query);
      this.deviceNo = this.$route.query.deviceNo;
      let param = {
        deviceNo: this.deviceNo
      };
      console.log(param);
      
      this.$postJson('dmc/medicine/box/upload/list', param).then((res) => {
        console.log(res.records);
        this.vdata = res.records;
      }).catch((err) => {
        console.error('获取数据失败:', err);
        this.$message.error('获取数据失败，请重试');
      });
    },
    
    // 处理编辑事件
    handleEdit(row) {
      console.log('编辑数据:', row);
      // 这里可以添加编辑逻辑，比如跳转到编辑页面
      this.$router.push({
        path: '/medicine/edit',
        query: {
          id: row.id,
          deviceNo: row.deviceNo
        }
      });
    },
    
    // 格式化时间（将"0000"转换为"未设置"，其他格式化为HH:MM）
    formatTime(timeStr) {
      if (!timeStr || timeStr === '0000' || timeStr === 'null') {
        return '未设置';
      }
      // 假设时间格式是HHMM，转换为HH:MM
      if (timeStr.length === 4) {
        return `${timeStr.substring(0, 2)}:${timeStr.substring(2, 4)}`;
      }
      return timeStr;
    },
    
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr || dateStr === '0000' || dateStr === 'null') {
        return '未设置';
      }
      // 可根据实际日期格式进行调整
      return dateStr;
    }
  },
  mounted() {
    this.getOldmanList();
  }
};
</script>

<style lang="scss" scoped>
/* 双层单元格样式 */
.time-cell {
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .time-line {
    font-size: 14px;
    color: #333;
    margin-bottom: 4px;
  }

  .medicine-line {
    font-size: 12px;
    color: #666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    text-align: center;
  }
}

/* 适配不同的屏幕 */
@media screen and (min-width: 1000px) and (max-width: 1530px) {
  .mudiaCol {
    width: 50% !important;
  }
  .formName .el-input__inner {
    width: 140px !important;
  }
}

@media screen and (min-width: 1531px) and (max-width: 1920px) {
  .mudiaCol {
    width: 33.333% !important;
  }
  .formName .el-input__inner {
    width: 180px !important;
  }
}

@media screen and (min-width: 1921px) {
  .mudiaCol {
    width: 33.333% !important;
  }
  .formName .el-input__inner {
    width: 180px !important;
  }
}
</style>
